import { useEffect, useState } from "react";
import api from "../api/api";

function PaymentHistory() {
  const [payments, setPayments] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    api.get("/payment/history")
      .then(res => setPayments(Array.isArray(res.data) ? res.data : []))
      .catch(() => setPayments([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-muted fs-13">Loading history…</p>;

  if (payments.length === 0) return (
    <div className="empty-state">
      <div className="empty-icon">🧾</div>
      <div className="empty-title">No payment history</div>
      <div className="empty-sub">Your past payments will appear here</div>
    </div>
  );

  return (
    <div>
      <div className="section-hdr mb-24">
        <div className="section-hdr-title">Payment History</div>
        <span className="badge badge-muted">{payments.length} records</span>
      </div>

      {payments.map(p => (
        <div className="pay-item" key={p.paymentId}>
          <div className="pay-item-info">
            <div className="pay-paper">{p.newspaperName || "Subscription"}</div>
            <div className="pay-meta">
              {p.paymentDate} &nbsp;·&nbsp; {p.paymentMode}
              {p.billingMonth && ` · ${p.billingMonth}/${p.billingYear}`}
            </div>
          </div>
          <div className="pay-item-right">
            <span className="pay-amount">₹{p.amount}</span>
            <span className={`badge ${p.status === "SUCCESS" ? "badge-success" : "badge-warning"}`}>
              {p.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default PaymentHistory;
